import React from "react";
import "./TestimonialsCarousel.css";

const testimonials = [
  {
    name: "Rahul Nimase",
    role: "Home Loan Customer",
    image: "/images/testimonials/harsh.jpg",
    text:
      "I recently transferred my home loan with the help of Monayra. The team made the process simple and guided me through every stage, including documentation, bank meetings and disbursement. Special thanks to Sonali Ma’am and Kapil Sir for their support and follow-ups.",
    rating: 5,
  },
  {
    name: "Sujit Pisal",
    role: "Home Loan Customer",
    image: "/images/testimonials/naina.jpg",
    text:
      "I had an excellent experience with Monayra. The service was smooth and transparent, especially the document handling, timely follow-ups and overall professionalism. The complete process was hassle-free and added real value.",
    rating: 5,
  },
  {
    name: "Suraj Nayak",
    role: "Business Owner",
    image: "/images/testimonials/amit.jpg",
    text:
      "A professional and responsive team that made the loan processing experience smooth and straightforward.",
    rating: 5,
  },
  {
    name: "Sandesh Lokhande",
    role: "Home Loan Customer",
    image: "/images/testimonials/priya.jpg",
    text:
      "For anyone considering a home loan or balance transfer, I highly recommend Monayra. Their expertise, regular communication and customer-focused support made a real difference throughout the process.",
    rating: 5,
  },
];

const repeatedTestimonials = [
  ...testimonials,
  ...testimonials,
];

export default function TestimonialsCarousel() {
  return (
    <section
      className="testimonials-section"
      aria-labelledby="testimonials-section-title"
    >
      <div
        className="testimonials-background-glow testimonials-glow-left"
        aria-hidden="true"
      ></div>

      <div
        className="testimonials-background-glow testimonials-glow-right"
        aria-hidden="true"
      ></div>

      <div className="testimonials-header">
        <span className="testimonials-eyebrow">
          Customer Experiences
        </span>

        <h2 id="testimonials-section-title">
          What our customers say about
          <span> their loan journey</span>
        </h2>

        <p>
          Read how Monayra helped customers simplify loan applications,
          documentation, balance transfers and disbursement.
        </p>
      </div>

      <div className="testimonials-carousel-wrapper">
        <div className="testimonials-fade testimonials-fade-left"></div>
        <div className="testimonials-fade testimonials-fade-right"></div>

        <div className="testimonials-carousel-track">
          {repeatedTestimonials.map((testimonial, index) => (
            <article
              className="testimonial-card"
              key={`${testimonial.name}-${index}`}
              aria-hidden={index >= testimonials.length}
            >
              <div className="testimonial-card-decoration"></div>

              <div className="testimonial-quote-icon">
                <i className="bi bi-quote"></i>
              </div>

              <p className="testimonial-text">
                {testimonial.text}
              </p>

              <div className="testimonial-rating">
                {Array.from(
                  { length: testimonial.rating },
                  (_, ratingIndex) => (
                    <i
                      className="bi bi-star-fill"
                      key={ratingIndex}
                      aria-hidden="true"
                    ></i>
                  )
                )}

                <span className="visually-hidden">
                  {testimonial.rating} out of 5 stars
                </span>
              </div>

              <div className="testimonial-card-footer">
                <div className="testimonial-customer">
                  <div className="testimonial-image-wrapper">
                    <img
                      src={testimonial.image}
                      alt={`${testimonial.name} testimonial`}
                      className="testimonial-image"
                      loading="lazy"
                      onError={(event) => {
                        event.currentTarget.style.display = "none";
                        event.currentTarget.parentElement.classList.add(
                          "image-fallback"
                        );
                      }}
                    />

                    <span className="testimonial-initials">
                      {testimonial.name
                        .split(" ")
                        .map((part) => part.charAt(0))
                        .slice(0, 2)
                        .join("")}
                    </span>
                  </div>

                  <div className="testimonial-customer-info">
                    <h3>{testimonial.name}</h3>
                    <p>{testimonial.role}</p>
                  </div>
                </div>

                <span className="testimonial-verified">
                  <i className="bi bi-patch-check-fill"></i>
                  Verified
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>

      <div className="testimonials-trust-row">
        <div>
          <i className="bi bi-shield-check"></i>
          Transparent process
        </div>

        <div>
          <i className="bi bi-headset"></i>
          Dedicated assistance
        </div>

        <div>
          <i className="bi bi-file-earmark-check"></i>
          Documentation support
        </div>
      </div>
    </section>
  );
}